import { useQuery, type UseQueryResult } from '@tanstack/solid-query';
import type { Client } from '@hey-api/client-fetch';
import type { Accessor } from 'solid-js';
import { getAccessPolicy, type GetAccessPolicyResponse } from '../generated';

export class TcEcomApiService {
  constructor(private readonly client: Client) {}

  public getAccessPolicyQuery(
    projectId: Accessor<string | undefined>
  ): UseQueryResult<GetAccessPolicyResponse, Error> {
    return useQuery(() => {
      const resolvedProjectId = projectId();

      return {
        queryKey: ['tc-ecom', 'access-policy', resolvedProjectId],
        enabled: resolvedProjectId !== undefined,
        queryFn: async (): Promise<GetAccessPolicyResponse> => {
          const response = await getAccessPolicy({
            client: this.client,
            query: {
              include: ['appAccess'],
              context: `projects:${resolvedProjectId}`,
            },
          });

          if (response.error) {
            throw new Error('Failed to get access policy');
          }

          return response.data;
        },
      };
    });
  }
}
